// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-field[data-v-497ccb0e]{margin-bottom:20px}.text-field[data-v-497ccb0e]  input[type=text]{border:1px solid #63666a}.text-field.error[data-v-497ccb0e]  div,.text-field.error[data-v-497ccb0e]  label{color:#b2140a}.text-field.error[data-v-497ccb0e]  input[type=text]{border:1px solid #b2140a}", ""]);
// Exports
module.exports = exports;
